import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OverflowGradientService {
  private _onScrollMap = new WeakMap<HTMLElement, EventListener>();

  toggleVerticalGradient(el: HTMLElement): void {
    const hasOverflow = el.scrollHeight > el.clientHeight;

    if (!hasOverflow) {
      el.classList.remove('overflow-gradient');
      const handler = this._onScrollMap.get(el);
      if (handler) el.removeEventListener('scroll', handler);
      this._onScrollMap.delete(el);
      return;
    }

    el.classList.add('overflow-gradient');

    if (this._onScrollMap.has(el)) {
      el.removeEventListener('scroll', this._onScrollMap.get(el));
    }

    const handler = () => {
      el.classList.remove('overflow-gradient');
      el.removeEventListener('scroll', handler);
      this._onScrollMap.delete(el);
    };

    el.addEventListener('scroll', handler);
    this._onScrollMap.set(el, handler);
  }

  toggleHorizontalGradient(el: HTMLElement): void {
    const hasOverflow = el.scrollWidth > el.clientWidth;

    if (!hasOverflow) {
      el.classList.remove('overflow-gradient');
      return;
    }

    el.classList.add('overflow-gradient');

    const handler = () => {
      el.classList.remove('overflow-gradient');
      el.removeEventListener('scroll', handler);
    };

    el.addEventListener('scroll', handler, { once: true });
  }
}
